var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49978 1.04582C1.8903 0.655298 2.52347 0.655298 2.91399 1.04582L10.3564 8.48822C10.3697 8.50156 10.3826 8.51518 10.395 8.52906L10.6563 8.79035C11.0468 9.18088 11.0468 9.81404 10.6563 10.2046L3.20441 17.6565C2.81388 18.047 2.18072 18.047 1.79019 17.6565L0.83051 16.6967C0.43991 16.3062 0.43991 15.673 0.83051 15.2825L6.61666 9.49636L0.540011 3.41976C0.149511 3.02924 0.149511 2.39607 0.540011 2.00555L1.49978 1.04582Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.f21c4b265e54be28928c702f0bdde301.svg";
export { ForwardRef as ReactComponent };